import { render, staticRenderFns } from "./edit-user-document.vue?vue&type=template&id=8191c824&scoped=true&"
import script from "./edit-user-document.vue?vue&type=script&lang=js&"
export * from "./edit-user-document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8191c824",
  null
  
)

export default component.exports